/**
 * Seed a candidate theme_config from a Look preset — see
 * `packages/site-templates/src/looks/seed.ts` for the tables. This shim only
 * narrows the return type to the web `DesignThemeConfig` (the package returns
 * the structurally identical `ThemeConfigSeed`, which it cannot name because it
 * has no dependency on web/).
 */
import { presetToThemeConfig as seedThemeConfig } from '@rumio/site-templates';
import type { PresetId } from '@rumio/site-templates';
import type { DesignThemeConfig } from '@/stores/design-preview-store';

export { FONT_PAIRS, PALETTE_FAMILIES } from '@rumio/site-templates';

/**
 * Build a full candidate theme_config from a preset: the Look bundle plus the
 * concrete colors and fonts implied by its palette family + font pair.
 */
export function presetToThemeConfig(presetId: PresetId): DesignThemeConfig {
  return seedThemeConfig(presetId);
}
